import React from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import SettingsIcon from "@mui/icons-material/Settings";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import BarChartIcon from "@mui/icons-material/BarChart";
import PersonIcon from "@mui/icons-material/Person";
import { useUser } from "../../../../users/providers/UserProvider";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const RightNavBar = () => {
  const [adminMenuAnchor, setAdminMenuAnchor] = useState<null | HTMLElement>(
    null
  );
  const navigate = useNavigate();
  const { user } = useUser();
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));

  const handleDesktopAdminMenuClick = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    setAdminMenuAnchor(event.currentTarget);
  };

  const handleDesktopAdminMenuClose = () => {
    setAdminMenuAnchor(null);
  };

  const handleAdminItemClick = (route: string) => {
    navigate(route);
    setAdminMenuAnchor(null);
  };

  return (
    <>
      {/* Desktop Admin Menu - Only show on large screens when user is admin */}
      {isLargeScreen && user?.isAdmin && (
        <Box sx={{ display: { xs: "none", md: "inline-flex" } }}>
          <IconButton
            size="large"
            color="inherit"
            aria-label="admin menu"
            onClick={handleDesktopAdminMenuClick}
            sx={{
              color: "#113355",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              },
            }}
          >
            <SettingsIcon />
          </IconButton>
          <Menu
            anchorEl={adminMenuAnchor}
            open={Boolean(adminMenuAnchor)}
            onClose={handleDesktopAdminMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            PaperProps={{
              sx: {
                mt: 1,
                minWidth: 200,
                "& .MuiMenuItem-root": {
                  px: 2,
                  py: 1,
                },
              },
            }}
          >
            <MenuItem onClick={() => handleAdminItemClick("/create-card")}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <AddCircleOutlineIcon fontSize="small" />
              </ListItemIcon>
              הוסף מוצר
            </MenuItem>
            <MenuItem onClick={() => handleAdminItemClick("/admin/categories")}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <img
                  src="/assets/icons/category.svg"
                  alt="Categories"
                  style={{ width: 20, height: 20 }}
                />
              </ListItemIcon>
              ניהול קטגוריות
            </MenuItem>
            <MenuItem onClick={() => handleAdminItemClick("/admin/coupons")}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <img
                  src="/assets/icons/coupon.svg"
                  alt="Coupon"
                  style={{ width: 20, height: 20 }}
                />
              </ListItemIcon>
              ניהול קופונים
            </MenuItem>
            <MenuItem onClick={() => handleAdminItemClick("/admin/marketing")}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <img
                  src="/assets/icons/window.svg"
                  alt="Marketing"
                  style={{ width: 20, height: 20 }}
                />
              </ListItemIcon>
              ניהול שיווק
            </MenuItem>
            <MenuItem onClick={() => handleAdminItemClick("/admin/customers")}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <PersonIcon fontSize="small" />
              </ListItemIcon>
              ניהול לקוחות
            </MenuItem>
            <MenuItem onClick={() => handleAdminItemClick("/admin/orders")}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <img
                  src="/assets/icons/order.svg"
                  alt="Orders"
                  style={{ width: 20, height: 20 }}
                />
              </ListItemIcon>
              ניהול הזמנות
            </MenuItem>
            <MenuItem
              onClick={() => handleAdminItemClick("/admin/sent-orders")}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>
                <img
                  src="/assets/icons/order.svg"
                  alt="Sent Orders"
                  style={{ width: 20, height: 20 }}
                />
              </ListItemIcon>
              הזמנות שנשלחו
            </MenuItem>
            <MenuItem onClick={() => handleAdminItemClick("/admin/analytics")}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <BarChartIcon fontSize="small" />
              </ListItemIcon>
              ניתוח נתונים
            </MenuItem>
          </Menu>
        </Box>
      )}
    </>
  );
};

export default RightNavBar;
